import type { Component } from "svelte";
import IconFlower from '~icons/mdi/flower';
import IconLeaf from '~icons/mdi/leaf';
import IconSnowflake from '~icons/mdi/snowflake';
import IconWhiteBalanceSunny from '~icons/mdi/white-balance-sunny';

export enum YearSeason {
    SPRING = 'SPRING',
    SUMMER = 'SUMMER',
    AUTUMN = 'AUTUMN',
    WINTER = 'WINTER',
}

export const YEAR_SEASON_ICONS: Record<YearSeason, Component> = {
    [YearSeason.SPRING]: IconFlower,
    [YearSeason.SUMMER]: IconWhiteBalanceSunny,
    [YearSeason.AUTUMN]: IconLeaf,
    [YearSeason.WINTER]: IconSnowflake,
};

export const YEAR_SEASON_COLOURS: Record<YearSeason, { text: string; bg: string }> = {
    [YearSeason.SPRING]: { text: 'text-green-700', bg: 'bg-green-600' },
    [YearSeason.SUMMER]: { text: 'text-red-700', bg: 'bg-red-600' },
    [YearSeason.AUTUMN]: { text: 'text-yellow-700', bg: 'bg-yellow-600' },
    [YearSeason.WINTER]: { text: 'text-blue-700', bg: 'bg-blue-600' },
};